/**
 * Ask Yogi typography + spacing tokens. Single source of truth for the
 * rendered conversation surface — swap values here when the official
 * design system lands.
 *
 * Tiers:
 * - fontSize.title       → h1, top-level section heading
 * - fontSize.section     → h2
 * - fontSize.subsection  → h3
 * - fontSize.detail      → h4-h6
 * - fontSize.body        → paragraphs, lists
 * - fontSize.table       → table cells
 * - fontSize.caption     → asset label tier (chart + table captions)
 * - fontSizeCompact.*    → same scale, tighter, for the Anywhere widget
 * - lineHeight.heading   → tight headings (1.3)
 * - lineHeight.dense     → table rows / data display (1.4)
 * - lineHeight.body      → flowing reading prose (1.6)
 * - spacing              → 4 / 8 / 12 / 16 / 24 / 32 grid
 * - color.text           → primary text
 * - color.muted          → asset captions, subordinate labels
 * - color.divider        → hr, table borders
 */
export const askYogiTokens = {
  fontSize: {
    title: '21px',
    section: '18px',
    subsection: '16px',
    detail: '15px',
    body: '15px',
    table: '14px',
    caption: '13px',
  },
  fontSizeCompact: {
    title: '17px',
    section: '15px',
    subsection: '14px',
    detail: '14px',
    body: '14px',
  },
  fontWeight: {
    heading: 600,
    emphasis: 500,
    body: 400,
  },
  lineHeight: {
    heading: 1.3,
    dense: 1.4,
    body: 1.6,
  },
  letterSpacing: {
    heading: '-0.01em',
    body: '-0.01em',
  },
  spacing: {
    xs: '4px',
    sm: '8px',
    md: '12px',
    lg: '16px',
    xl: '24px',
    xxl: '32px',
  },
  color: {
    text: '#1f1f1e',
    muted: '#525252',
    divider: '#e5e5e3',
    tableBorder: '#e5e5e3',
    tableHeaderBg: '#f7f7f5',
    tableRowAlt: '#fafaf9',
    iconBg: '#f5f5f5',
    iconBgHover: '#e8e8e8',
    iconHover: '#337ea9',
    iconText: '#666',
    link: '#1890ff',
    codeBg: 'rgba(0, 0, 0, 0.06)',
    quoteBorder: 'rgba(0, 0, 0, 0.15)',
    quoteText: 'rgba(0, 0, 0, 0.7)',
  },
} as const
